/* eslint-disable */
import type { Region } from "../../../../franklin/region.pb";
import type { Feature } from "../../../cashstorefronts/api/BusinessProfile.pb";
import type { Channel } from "../../../cashstorefronts/api/Channel.pb";
import type { OfferType } from "../../../cashstorefronts/api/Offer.pb";
import type { FilterEntityType } from "./entity.pb";
import type { OfferStatus } from "./offerStatus.pb";

export enum LogicOperator {
  OR = "OR",
  AND = "AND",
}

export interface BusinessFilter {
  /** required. filter to retain businesses with any of the given features */
  features?: Feature[];
  /**
   * filter to retain businesses with the given bizzy tokens
   * the order will be maintained in the results if sorting is not applied
   */
  bizzy_tokens?: string[];
  /**
   * filter to retain businesses with the given business profile tokens
   * the order will be maintained in the results if sorting is not applied
   */
  business_profile_tokens?: string[];
  /** filter to retain businesses under any of the given categories */
  categories?: string[];
  /** filter to retain businesses with given tags */
  tags?: MultiValueFilter;
  /** Risk Filtering -> prevent users from accessing stores through SUP */
  excluded_ap_store_ids?: string[];
  /**
   * filter to retain businesses with the given merchantein merchant tokens
   * the order will be maintained in the results if sorting is not applied
   */
  merchantein_tokens?: string[];
}

export interface OfferFilter {
  /**
   * filter to retain offers with given tokens
   * the order will be maintained in the results if sorting is not applied
   */
  tokens?: string[];
  /** required. filter to retain offers with any of the given types */
  types?: OfferType[];
  /** filter to retain offers with any of the given offer statuses */
  offer_statuses?: OfferStatus[];
  /** filter to retain offers with any of the given channels */
  channels?: Channel[];
  /**
   * filter offers by start time
   * required unless live_offer_only is set
   */
  start_time_filter?: TimeFilter;
  /**
   * filter offers by end time
   * required unless live_offer_only is set
   */
  end_time_filter?: TimeFilter;
  /** filter only live offers. if set, the start_time_filter, end_time_filter and offer_statuses will be ignored */
  live_offer_only?: boolean;
}

export interface CustomerFilter {
}

export interface AppFeatureFilter {
  region?: Region;
  isTeen?: boolean;
}

export interface FilterEntityFilter {
  /** filter to retain filter entities with given tokens */
  tokens?: string[];
  /** filter to retain filter entities with any of the given types */
  types?: FilterEntityType[];
  /**
   * applied filter entities with given tokens
   * we do not support multiple filters for the same type
   */
  applied_tokens?: string[];
}

/** filter on a field with multiple values by the specified operator. */
export interface MultiValueFilter {
  values?: string[];
  logic_operator?: LogicOperator;
}

export interface TimeFilter {
  /** the time in the document is before the given time */
  time_before_ms?:
    | number
    | undefined;
  /** the time in the document is after the given time */
  time_after_ms?: number | undefined;
}
